(() => {
  const root = document.documentElement;
  const storageKey = 'khaos-theme-preference';
  const validModes = new Set(['dark', 'light']);

  if (root.dataset.khaosThemeEnabled !== 'true') return;

  const rememberChoice = root.dataset.khaosThemeRemember !== 'false';
  const defaultMode = root.dataset.khaosThemeDefault || 'dark';
  const systemQuery = window.matchMedia('(prefers-color-scheme: light)');
  let hasExplicitChoice = false;

  const readStoredMode = () => {
    if (!rememberChoice) return null;
    try {
      const value = window.localStorage.getItem(storageKey);
      return validModes.has(value) ? value : null;
    } catch (_error) {
      return null;
    }
  };

  const updateMetaThemeColor = (mode) => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    meta.setAttribute(
      'content',
      mode === 'light'
        ? root.dataset.khaosThemeLightColor || '#F4F0E7'
        : root.dataset.khaosThemeDarkColor || '#0A0A0A'
    );
  };

  const syncControls = (mode) => {
    const nextMode = mode === 'dark' ? 'light' : 'dark';
    const nextLabel = `Switch to ${nextMode} mode`;

    document.querySelectorAll('[data-khaos-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(mode === 'light'));
      button.setAttribute('aria-label', nextLabel);
      button.setAttribute('title', nextLabel);
      const label = button.querySelector('[data-khaos-theme-toggle-label]');
      if (label) label.textContent = nextLabel;
    });
  };

  const applyMode = (mode, options = {}) => {
    const safeMode = validModes.has(mode) ? mode : 'dark';
    root.dataset.khaosTheme = safeMode;
    root.style.colorScheme = safeMode;
    updateMetaThemeColor(safeMode);
    syncControls(safeMode);

    if (options.persist && rememberChoice) {
      try {
        window.localStorage.setItem(storageKey, safeMode);
      } catch (_error) {
        // The visual switch still works when storage is unavailable.
      }
    }

    window.dispatchEvent(new CustomEvent('khaos:themechange', { detail: { mode: safeMode } }));
  };

  const storedMode = readStoredMode();
  hasExplicitChoice = Boolean(storedMode);

  const initialMode = validModes.has(root.dataset.khaosTheme)
    ? root.dataset.khaosTheme
    : storedMode || (defaultMode === 'system' ? (systemQuery.matches ? 'light' : 'dark') : defaultMode);

  const initialize = () => {
    applyMode(initialMode);

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-khaos-theme-toggle]');
      if (!button) return;
      hasExplicitChoice = true;
      applyMode(root.dataset.khaosTheme === 'light' ? 'dark' : 'light', { persist: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  const handleSystemChange = (event) => {
    if (defaultMode !== 'system' || hasExplicitChoice) return;
    applyMode(event.matches ? 'light' : 'dark');
  };

  if (typeof systemQuery.addEventListener === 'function') {
    systemQuery.addEventListener('change', handleSystemChange);
  } else if (typeof systemQuery.addListener === 'function') {
    systemQuery.addListener(handleSystemChange);
  }

  document.addEventListener('shopify:section:load', () => {
    syncControls(validModes.has(root.dataset.khaosTheme) ? root.dataset.khaosTheme : 'dark');
  });

  window.addEventListener('storage', (event) => {
    if (!rememberChoice || event.key !== storageKey || !validModes.has(event.newValue)) return;
    hasExplicitChoice = true;
    applyMode(event.newValue);
  });
})();
